var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShowOnMapOutlined({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m19 17.558-3 1V6.775l3-1v.665A4.787 4.787 0 0 1 21 6V4.387a1 1 0 0 0-1.316-.948L15 5 9 3 3.684 4.772A1 1 0 0 0 3 5.721v13.892a1 1 0 0 0 1.316.948L9 19l6 2 5.316-1.772.016-.006.019-.006A40.505 40.505 0 0 1 19 17.436v.122ZM8 5.442v11.783l-3 1V6.442l3-1Zm2 0v11.783l4 1.333V6.775l-4-1.333Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17s3-3.6 3-5.85C24 9.35 22.657 8 21 8s-3 1.35-3 3.15C18 13.4 21 17 21 17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShowOnMapOutlined);
export default __webpack_public_path__ + "static/media/ic_show_on_map_outlined.f991fa9fde78382dc1f4e251e59c0497.svg";
export { ForwardRef as ReactComponent };